import {useCallback, useEffect, useState} from "react";
import useEmblaCarousel from "embla-carousel-react";
import {EmblaOptionsType} from "embla-carousel";

export const useMainDiamondsCarousel = (count: number) => {
    const [scrollSnaps, setScrollSnaps] = useState<number[]>([]);
    const [selectedSnap, setSelectedSnap] = useState<number>(0);

    const options: EmblaOptionsType = {
        loop: count > 1,
        align: "start",
    }

    const [carouselRef, carouselApi] = useEmblaCarousel(options);

    const scrollTo = useCallback((index) => {
        carouselApi?.scrollTo(index);
    }, [carouselApi]);

    useEffect(() => {
        if (!carouselApi) return;

        const onReInit = (api) => {
            setScrollSnaps(api.scrollSnapList());
            setSelectedSnap(api.selectedScrollSnap());
        };

        const onSelect = (api) => {
            setSelectedSnap(api.selectedScrollSnap());
        };

        onReInit(carouselApi);

        carouselApi.on('reInit', onReInit);
        carouselApi.on('select', onSelect);

        return () => {
            carouselApi.off('reInit', onReInit);
            carouselApi.off('select', onSelect);
        };
    }, [carouselApi]);

    const scrollPrev = useCallback(() => {
        carouselApi?.scrollPrev();
    }, [carouselApi]);

    const scrollNext = useCallback(() => {
        carouselApi?.scrollNext();
    }, [carouselApi]);

    return {
        carouselRef,
        carouselApi,
        scrollSnaps,
        selectedSnap,
        scrollTo,
        scrollPrev,
        scrollNext,
    };
}
